export enum ReturnType {
    SpecialExpressReturn = "SpecialExpressReturn",
    ServEngrAndInternReturn = "ServEngrAndInternReturn",
    CustomerServiceReturn = "CustomerServiceReturn",
    SpecialNumber1DealerReturn = "SpecialNumber1DealerReturn",
    SpecialNumber2DealerReturn = "SpecialNumber2DealerReturn",
    TransitionReturn = "TransitionReturn",
    TerminationReturn = "TerminationReturn",
    AnnualReturnProgram = "AnnualReturnProgram",
    ExpressReturnProgram = "ExpressReturnProgram",
    PromatchExpressReturn = "PromatchExpressReturn",
    PromatchAnnualReturn = "PromatchAnnualReturn",
    SapExpressReturn = "SapExpressReturn",
    SapSurplusReturn = "SapSurplusReturn",
    SapSpecialReturn = "SapSpecialReturn",
    SapDirectReturn = "SapDirectReturn",
    SapRapidReturn = "SapRapidReturn",
}
